import axios from 'axios';
import toast from 'react-hot-toast';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_WALLET_API_BASE_URL || 'https://wallet.cloudvolte.com/api/wallet',
    headers: { 'Content-Type': 'application/json' },
    timeout: 30000,
});

// ── Request Interceptor ────────────────────────────────────────────
apiClient.interceptors.request.use((config) => {
    // Master API key from localStorage (set after login), fallback to env
    const masterKey = localStorage.getItem('WifiApiKey') || process.env.REACT_APP_WALLET_MASTER_API_KEY || "";
    if (masterKey) {
        config.headers['x-api-key'] = masterKey;
    }

    // Wallet API key from sessionStorage (fallback to static dev value)
    const walletApiKey = localStorage.getItem('WalletApiKey') ||"";
    config.headers['x-wallet-api-key'] = walletApiKey;

    // User ID from sessionStorage (fallback to static dev value)
    const userId = localStorage.getItem('EmpId') || '';
    config.headers['x-user-id'] = userId;

    return config;
});

// ── Response Interceptor ───────────────────────────────────────────
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const status = error.response?.status;

        // Rate limit handling
        if (status === 429) {
            const retryAfter = error.response.headers['retry-after'] || 5;
            toast.error(`Rate limited. Retrying in ${retryAfter}s…`);
            await new Promise((r) => setTimeout(r, retryAfter * 1000));
            return apiClient(error.config);
        }

        // Extract backend error messages
        const data = error.response?.data;
        if (data && !data.success && Array.isArray(data.errors)) {
            const msg = data.errors.map((e) => e.msg).join(', ');
            toast.error(msg || 'An error occurred');
        } else if (status === 401 || status === 403) {
            toast.error('Authentication failed. Please check your API key.');
        } else if (!error.response) {
            toast.error('Network error. Please check your connection.');
        }

        return Promise.reject(error);
    }
);

export default apiClient;
